export type TranscriptCacheDebug = {
  cache_enabled?: boolean;
  cache_hit?: boolean;
  cache_miss_reason?: string;
  cache_source?: string;
  cache_ttl_days?: number;
  cache_strict?: boolean;
  data_package_version?: string | null;
};

const STATUS_STYLE: Record<string, string> = {
  HIT: "color:#15CB4A;font-weight:bold",
  MISS: "color:#E6A800;font-weight:bold",
  DISABLED: "color:#F84241;font-weight:bold",
};

export function logTranscriptCache(step: string, payload?: TranscriptCacheDebug) {
  const enabled = payload?.cache_enabled;
  const hit = Boolean(payload?.cache_hit);
  const status = enabled === false ? "DISABLED" : hit ? "HIT" : "MISS";

  console.info(
    `%c[transcript-cache] ${status}`,
    STATUS_STYLE[status],
    {
      step,
      enabled,
      hit,
      missReason: payload?.cache_miss_reason,
      source: payload?.cache_source ?? step,
      ttlDays: payload?.cache_ttl_days,
      strict: payload?.cache_strict,
      dataPackageVersion: payload?.data_package_version,
    }
  );
}
